module.exports = { "default": require("core-js/library/fn/set"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/set.js